(function () {
  var root = document.getElementById('ai_shop_assistant');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('aisa-config').textContent); } catch (e) {}
  var ROOT = (cfg.root || '/').replace(/\/?$/, '/');
  var MAX = cfg.results || 4;

  var panel = root.querySelector('.aisa-panel');
  var launcher = root.querySelector('.aisa-launcher');
  var log = root.querySelector('[data-aisa-log]');
  var input = root.querySelector('[data-aisa-input]');
  var sendBtn = root.querySelector('[data-aisa-send]');

  /* ---------- Topics: what shoppers ask for → catalog types / keywords ---------- */
  var INTENTS = [
    { id: 'skin', icon: '🧴', label: 'Skin & face care', words: ['skin','skincare','face','facial','serum','moisturiser','moisturizer','cleanser','face wash','toner','essence','face mask','acne','pimple','wrinkle','wrinkles','anti aging','ageing','pigmentation','dark circle','dark circles','dry skin','oily skin','eczema','psoriasis','glow','pores','blackhead'], types: ['face','serum','cleanser','toner','moistur','skin care','essences','masks','scrubs','cream','eye cream','blemish'], terms: ['serum','cleanser','moisturiz','toner','face','skin','cream','essence','acne','retinol','hyaluronic','niacinamide','vitamin c'], reply: 'Skin care from the store — tell me your skin type or concern and I can narrow it down:' },
    { id: 'kbeauty', icon: '✨', label: 'Korean beauty (K-Beauty)', words: ['korean','korea','k beauty','kbeauty','k-beauty','cosrx','joseon','beauty of joseon','snail','snail mucin','glass skin','ampoule','sheet mask','korean skincare'], types: ['kbeauty','essences'], terms: ['cosrx','joseon','kbeauty','korean','snail','essence','ampoule','mucin'], reply: 'Our Korean beauty range — COSRX, Beauty of Joseon and more:' },
    { id: 'sun', icon: '☀️', label: 'Sun care & sunscreen', words: ['sunscreen','sun screen','sunblock','sun block','spf','sun','sunburn','after sun','tanning','tan'], types: ['sunscreen','sun block','suncream','sun care','sun gel','sun lotion','tanning'], terms: ['spf','sunscreen','suncream','sunblock','sun care','after sun','tanning'], reply: 'Sun protection we stock:' },
    { id: 'hair', icon: '💇', label: 'Hair care', words: ['hair','shampoo','conditioner','dandruff','hair fall','hair loss','thinning','hair oil','hair colour','hair color','dye','frizz','curly','scalp','lice'], types: ['shampoo','conditioner','hair care','hair color','hair oil','hair styling','hair cleanser','head lice'], terms: ['shampoo','conditioner','hair','scalp','dandruff','minoxidil','keratin'], reply: 'For hair, here is what we have:' },
    { id: 'baby', icon: '👶', label: 'Mother & baby', words: ['baby','babies','infant','newborn','toddler','kids','diaper','diapers','nappy','wipes','pacifier','teether','feeding bottle','nipple','breast pump','breastfeeding','pregnancy','pregnant','mom','mother','nursing','formula','baby lotion','baby wash'], types: ['baby','diaper','wipes','pacifier','nursing','breast pump','pregnancy','kids'], terms: ['baby','diaper','wipe','pacifier','teether','breast pump','nursing','infant','newborn','kids'], reply: 'For mother and baby:' },
    { id: 'vitamins', icon: '💊', label: 'Vitamins & supplements', words: ['vitamin','vitamins','multivitamin','supplement','supplements','immunity','immune','zinc','magnesium','calcium','iron','omega','fish oil','probiotic','probiotics','gummies','collagen','biotin','folic','deficiency','energy levels','tiredness'], types: ['vitamin','multivitamin','multi-vitamin','fish oil','omega','probiotics','calcium','chewable','collagen','joint support','antioxidant'], terms: ['vitamin','multivit','omega','fish oil','probiotic','calcium','zinc','magnes','collagen','biotin','iron'], reply: 'Vitamins and daily supplements:' },
    { id: 'herbs', icon: '🌿', label: 'Herbal & natural', words: ['herbal','herb','herbs','natural','organic','ginseng','turmeric','curcumin','garlic','ginkgo','honey','manuka','greens','superfood','detox','tea'], types: ['ginseng','honey','tea','organic food','aloe'], terms: ['ginseng','turmeric','curcumin','garlic','ginkgo','manuka','honey','greens','herbal','organic'], reply: 'Herbal and natural options:' },
    { id: 'body', icon: '🧼', label: 'Bath & body care', words: ['body wash','shower gel','shower','soap','body lotion','body cream','body butter','moisturiser for body','scrub','deodorant','antiperspirant','roll on','hand cream','foot cream','heel','perfume','fragrance','body oil','body powder'], types: ['body wash','shower gel','bar soap','body lotion','lotion & moisturizer','deodorant','hand cream','foot care','bath & body','body oil','body powder','fragrance','perfume'], terms: ['body wash','shower','soap','body lotion','deodorant','hand cream','foot','scrub','perfume'], reply: 'Bath and body care:' },
    { id: 'oral', icon: '🦷', label: 'Oral care', words: ['toothpaste','tooth paste','toothbrush','tooth brush','mouthwash','mouth wash','teeth','dental','gums','floss','bad breath','whitening'], types: ['toothpaste','toothbrush','mouthwash','oral care','breath spray'], terms: ['toothpaste','toothbrush','mouthwash','dental','floss','breath'], reply: 'For oral care:' },
    { id: 'men', icon: '🪒', label: 'Men\'s grooming', words: ['men','mens','shaving','shave','razor','beard','trimmer','clipper','aftershave','shaving cream','shaving gel'], types: ['shaving','shaving cream','shaving gel','shaving form','hair clippers','epilators'], terms: ['shaving','razor','beard','trimmer','aftershave','men'], reply: 'Men\'s grooming:' },
    { id: 'feminine', icon: '🌸', label: 'Feminine & intimate care', words: ['sanitary','pads','tampon','tampons','feminine','intimate','period','menstrual','hair removal','waxing','condom','condoms','lubricant','pregnancy test','contraceptive'], types: ['feminine','tampons','pad','condoms','lubricants','pregnancy tests','hair removal','personal lubricants'], terms: ['sanitary','pads','tampon','intimate','feminine','condom','lubricant','pregnancy test','hair removal'], reply: 'Feminine and intimate care:' },
    { id: 'devices', icon: '🩺', label: 'Health monitors & devices', words: ['monitor','bp','blood pressure','glucose','glucometer','sugar test','diabetes','thermometer','temperature','oximeter','oxygen','nebulizer','nebuliser','inhaler','weighing scale','scale','weight machine','humidifier','stethoscope','test strips','lancet','cholesterol'], types: ['blood pressure','glucose','thermometer','oximeter','nebulizer','scales','humidifier','steam inhaler','stethoscope','lancing','cholesterol','digital scale','nasal'], terms: ['monitor','glucose','thermometer','oximeter','nebuliz','scale','blood pressure','test strip','beurer','omron'], reply: 'Home health monitors and devices:' },
    { id: 'support', icon: '🦽', label: 'Mobility & supports', words: ['support','brace','braces','wheelchair','walker','crutch','crutches','walking stick','cane','knee','ankle','elbow','back support','abdominal','shoulder','incontinence','adult diaper','bandage'], types: ['supports & braces','canes','incontinence','tennis elbow','bunion','abdominal','medical tape','adult diaper','socks'], terms: ['support','brace','wheelchair','walker','crutch','knee','ankle','elbow','bandage','incontinence'], reply: 'Mobility aids and orthopedic supports:' },
    { id: 'sports', icon: '💪', label: 'Sports nutrition & protein', words: ['protein','whey','isolate','casein','creatine','bcaa','eaa','amino','glutamine','pre workout','preworkout','pre-workout','mass gainer','weight gainer','gym','muscle','workout','shaker','carnitine','fat burner','weight loss'], types: ['protein','whey','casein','creatine','bcaa','amino','pre workout','pre-workout','preworkout','mass gainer','glutamine','intra workout','shaker','energy','l carnitine'], terms: ['protein','whey','isolate','creatine','bcaa','amino','pre workout','gainer','glutamine','carnitine'], reply: 'Sports nutrition from the store:' },
    { id: 'pet', icon: '🐾', label: 'Pet wellness', words: ['pet','pets','dog','dogs','cat','cats','puppy','kitten','pet food','dog food','cat food','animal'], types: ['pet','pet wellness','pet product','pet accessories'], terms: ['cat food','dog food','royal canin','pet','puppy','kitten','feline','canine','josera','reflex'], reply: 'For your pet:' },
    { id: 'pain', icon: '🤕', label: 'Pain relief & first aid', words: ['pain','painkiller','pain relief','ache','headache','muscle pain','joint pain','balm','ointment','bandage','first aid','antiseptic','plaster'], types: ['pain relief','ointment','balm','medical tape','medicine & drugs','hand sanitizers'], terms: ['pain relief','balm','ointment','bandage','antiseptic','gel'], reply: 'Pain relief and first aid:' }
  ];

  /* Arabic keywords for the same topics. Only the detection words are translated:
     the product types and scoring terms stay English, because that is what the
     catalog contains, so an Arabic question still matches the right products. */
  var ARABIC_WORDS = {
    skin: ['بشرة','العناية بالبشرة','سيروم','كريم للوجه','غسول الوجه','ترطيب','حب الشباب','تجاعيد','تصبغات','مرطب'],
    kbeauty: ['كوري','كورية','منتجات كورية','العناية الكورية','كوزركس'],
    sun: ['واقي شمس','واقي الشمس','حماية من الشمس','حروق الشمس','تسمير'],
    hair: ['شعر','الشعر','شامبو','بلسم','قشرة','تساقط الشعر','زيت الشعر','صبغة'],
    baby: ['طفل','أطفال','اطفال','رضيع','حفاضات','مناديل مبللة','رضاعة','حليب أطفال','حامل','الحمل','مرضعة','شفاط حليب'],
    vitamins: ['فيتامين','فيتامينات','مكملات','مناعة','زنك','مغنيسيوم','كالسيوم','حديد','أوميغا','اوميغا','زيت السمك','بروبيوتيك','كولاجين'],
    herbs: ['أعشاب','اعشاب','عشبي','طبيعي','جنسنج','جنسنغ','كركم','ثوم','عسل','مانوكا','ديتوكس'],
    body: ['غسول الجسم','صابون','لوشن','مرطب الجسم','مزيل العرق','كريم اليدين','كريم القدم','عطر','مقشر'],
    oral: ['معجون أسنان','معجون اسنان','فرشاة أسنان','غسول الفم','أسنان','اسنان','رائحة الفم'],
    men: ['رجالي','حلاقة','شفرة','لحية','ماكينة حلاقة','بعد الحلاقة'],
    feminine: ['فوط صحية','فوط','نسائي','نسائية','العناية الحميمة','دورة شهرية','إزالة الشعر','واقي ذكري','اختبار حمل'],
    devices: ['جهاز','قياس الضغط','ضغط الدم','جهاز السكر','سكري','ميزان حرارة','حرارة','مقياس الأكسجين','بخاخ','جهاز استنشاق','ميزان','شرائط الفحص'],
    support: ['دعامة','مشد','كرسي متحرك','مشاية','عكاز','ركبة','كاحل','كوع','ظهر','حفاضات كبار'],
    sports: ['بروتين','واي','ايزوليت','كرياتين','أحماض أمينية','امينو','ما قبل التمرين','زيادة الوزن','جينر','عضلات','جيم','حرق الدهون'],
    pet: ['حيوانات أليفة','قطط','كلاب','طعام قطط','طعام كلاب','قطة','كلب'],
    pain: ['ألم','الم','مسكن','صداع','بلسم','مرهم','ضمادة','إسعافات أولية']
  };
  INTENTS.forEach(function (it) { if (ARABIC_WORDS[it.id]) it.words = it.words.concat(ARABIC_WORDS[it.id]); });

  var STARTERS = ['skin','kbeauty','baby','vitamins','hair','body','devices','sports','pet'];
  var SPECIFIC = ['kbeauty','sun','oral','men','feminine','devices','support','pet','pain','herbs'];
  var EXAMPLES = ['Serum for acne', 'Sunscreen for face', 'Vitamin D tablets', 'Baby diapers', 'Blood pressure monitor', 'Do you deliver?'];
  var MIN_SCORE = 9;
  var GENERIC = ['what','whats','why','how','when','where','who','which','does','did','can','could','should','would','will','good','better','best','take','use','using','work','works','much','many','more','most','about','tell','know','there','this','that','these','those','they','them','their','have','has','had','was','were','been','being','time','day','daily','after','before','body','people','person','women','woman','men','man','year','years','old','also','just','like','really','very','your','store','shop','product','products','price','cost','show','want','need','recommend','suggest','please','thanks','other','than','then','with','without','from','into','only','same','different','difference','between','kind','type','types','option','options'];
  var STOP = 'a an and are best buy can do for from get give good have help i im i\'m in is it looking me my need of on or please recommend show some something suggest that the to want what which with you your any'.split(' ');

  /* ---------- Catalog ---------- */
  var catalog = null, loading = null;
  var CKEY = 'aisa_catalog_v5';
  var CKEEP = 12 * 60 * 60 * 1000;   // the catalog is re-fetched at most twice a day
  function cacheGet() {
    try { var a = localStorage.getItem(CKEY); if (a) return JSON.parse(a); } catch (e) {}
    try { var b = sessionStorage.getItem(CKEY); if (b) return JSON.parse(b); } catch (e) {}
    return null;
  }
  function cacheSet(p) {
    var s = JSON.stringify({ t: Date.now(), p: p });
    try { localStorage.setItem(CKEY, s); return; } catch (e) {}
    try { sessionStorage.setItem(CKEY, s); } catch (e) {}
  }
  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    if (loading) return loading;
    try {
      var cached = cacheGet();
      if (cached && Date.now() - cached.t < CKEEP) { catalog = cached.p; return Promise.resolve(catalog); }
    } catch (e) {}
    var all = [];
    function page(n) {
      return fetch(ROOT + 'products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('catalog ' + r.status); return r.json(); })
        .then(function (d) {
          var list = (d.products || []).map(slim);
          all = all.concat(list);
          if (list.length === 250 && n < 20) return page(n + 1);
          return all;
        });
    }
    loading = page(1).then(function (p) {
      if (p && p.length) { catalog = p; cacheSet(p); return p; }
      loading = null; catalog = null; return [];   // empty result: don't cache it, try again next time
    }).catch(function () {
      loading = null; catalog = null; return [];   // a failed load must not disable products for the session
    });
    return loading;
  }

  // Warm from the cache synchronously at start-up, so cards restored from an
  // earlier conversation are re-priced from current data rather than stale text.
  try {
    var warm = cacheGet();
    if (warm && warm.p && warm.p.length && Date.now() - warm.t < CKEEP) catalog = warm.p;
  } catch (e) {}
  function freshen(p) {
    if (!catalog || !catalog.length || !p || !p.h) return p;
    for (var i = 0; i < catalog.length; i++) if (catalog[i].h === p.h) return catalog[i];
    return p;
  }
  function slim(p) {
    var v = p.variants || [];
    var avail = v.filter(function (x) { return x.available; });
    var pick = (avail[0] || v[0] || {});
    var prices = v.map(function (x) { return parseFloat(x.price); }).filter(function (n) { return !isNaN(n); });
    var min = prices.length ? Math.min.apply(null, prices) : 0;
    var max = prices.length ? Math.max.apply(null, prices) : 0;
    var single = v.length <= 1;
    var cmp = single ? (parseFloat(pick.compare_at_price) || 0) : 0;
    var body = (p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 300);
    return {
      t: p.title, h: p.handle, ty: (p.product_type || ''), vd: (p.vendor || ''),
      tg: (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).join(' '),
      b: body, img: p.images && p.images[0] ? p.images[0].src : '',
      pr: min, px: max, nv: v.length,
      cp: cmp > min ? cmp : 0,
      // The flavours and sizes themselves, so the card can offer a picker
      // instead of guessing one on the shopper's behalf.
      vs: v.slice(0, 24).map(function (x) {
        return { i: x.id, n: x.title || 'Default', a: !!x.available, p: parseFloat(x.price) || 0 };
      }),
      // A one-variant product can always be added straight to the cart.
      vid: single ? pick.id : null,
      av: avail.length > 0,
      created: p.published_at || p.created_at || ''
    };
  }

  /* ---------- Understanding the question ---------- */
  function norm(s) { return (' ' + String(s).toLowerCase().replace(/[^a-z0-9؀-ۿ%.\-\s]/g, ' ').replace(/\s+/g, ' ') + ' '); }
  function hasWord(text, w) { return text.indexOf(' ' + w + ' ') !== -1 || text.indexOf(' ' + w + 's ') !== -1 || text.indexOf(' ' + w + 'es ') !== -1; }

  function parse(q) {
    var n = norm(q);
    var intents = INTENTS.filter(function (it) { return it.words.some(function (w) { return hasWord(n, w); }); });
    if (intents.length > 1) {
      var specific = intents.filter(function (it) { return SPECIFIC.indexOf(it.id) !== -1; });
      if (specific.length) intents = specific;
    }
    var price = {};
    var m;
    if ((m = n.match(/between\s*(\d+)\s*(?:and|-|to)\s*(\d+)/))) { price.min = +m[1]; price.max = +m[2]; }
    else {
      if ((m = n.match(/(?:under|below|less than|cheaper than|max|upto|up to|within|budget(?: of)?)\s*(?:aed|dhs|dh)?\s*(\d+)/))) price.max = +m[1];
      if ((m = n.match(/(?:over|above|more than|min|at least)\s*(?:aed|dhs|dh)?\s*(\d+)/))) price.min = +m[1];
    }
    var sort = null;
    if (/\b(cheap|cheapest|budget|affordable|lowest price|low price|inexpensive)\b/.test(n)) sort = 'asc';
    if (/\b(premium|expensive|best quality|top end|highest price)\b/.test(n)) sort = 'desc';
    if (/\b(new|newest|latest|just arrived|new arrivals)\b/.test(n)) sort = 'new';
    if (/\b(sale|discount|offer|deal|deals|promo)\b/.test(n)) sort = 'sale';
    var tokens = n.trim().split(' ').filter(function (t) {
      return t.length > 1 && STOP.indexOf(t) === -1 && !/^\d+$/.test(t) && ['aed','dhs','dh','under','below','over','above','cheap','cheapest','price','budget'].indexOf(t) === -1;
    });
    return { raw: q, n: n, intents: intents, price: price, sort: sort, tokens: tokens };
  }

  function vendorsIn(n) {
    if (!catalog) return [];
    var seen = {};
    catalog.forEach(function (p) { if (p.vd) seen[p.vd.toLowerCase()] = p.vd; });
    return Object.keys(seen).filter(function (v) { return v.length > 2 && n.indexOf(' ' + v) !== -1; });
  }

  function search(pq) {
    var vendors = vendorsIn(pq.n);
    var scored = catalog.map(function (p) {
      var title = norm(p.t), type = norm(p.ty), tags = norm(p.tg), body = norm(p.b), vend = p.vd.toLowerCase();
      var s = 0;
      pq.intents.forEach(function (it) {
        if (it.types.some(function (ty) { return type.indexOf(ty) !== -1 || tags.indexOf(ty) !== -1; })) s += 12;
        it.terms.forEach(function (term) {
          if (title.indexOf(' ' + term) !== -1) s += 10;
          else if (title.indexOf(term) !== -1) s += 5;
          else if (body.indexOf(term) !== -1) s += 1;
        });
      });
      var titleHits = 0;
      pq.tokens.forEach(function (tk) {
        if (tk.length < 3 || GENERIC.indexOf(tk) !== -1) return;
        if (title.indexOf(' ' + tk) !== -1) { s += 6; titleHits++; }
        else if (tk.length > 4 && title.indexOf(tk) !== -1) { s += 3; titleHits++; }
        if (type.indexOf(' ' + tk) !== -1 || tags.indexOf(' ' + tk) !== -1) s += 3;
      });
      if (titleHits >= 2) s += 4;
      if (vendors.length) { if (vendors.indexOf(vend) !== -1) s += 10; else s -= 50; }
      if (pq.price.max != null && p.pr > pq.price.max) s = -999;
      if (pq.price.min != null && p.pr < pq.price.min) s = -999;
      if (pq.sort === 'sale' && !p.cp) s -= 20;
      if (!p.av) s -= 4;
      return { p: p, s: s };
    });
    var needsMatch = pq.intents.length || pq.tokens.some(function (t) { return t.length > 2; }) || vendors.length;
    var hits = scored.filter(function (x) { return x.s >= (needsMatch ? MIN_SCORE : 1000); });
    if (pq.sort === 'asc') hits.sort(function (a, b) { return a.p.pr - b.p.pr || b.s - a.s; });
    else if (pq.sort === 'desc') hits.sort(function (a, b) { return b.p.pr - a.p.pr || b.s - a.s; });
    else if (pq.sort === 'new') hits.sort(function (a, b) {
      var x = a.p.created || '', y = b.p.created || '';
      return x < y ? 1 : (x > y ? -1 : b.s - a.s);
    });
    else hits.sort(function (a, b) { return (b.p.av - a.p.av) || (b.s - a.s); });
    return { list: hits.map(function (x) { return x.p; }), vendors: vendors };
  }

  function predictive(q) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + MAX + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
      return ps.map(function (p) {
        var vs = p.variants || [], one = vs.length <= 1;
        var okv = null;
        for (var i = 0; i < vs.length; i++) if (vs[i] && vs[i].available !== false) { okv = vs[i]; break; }
        return { t: p.title, h: p.handle, ty: p.type || '', vd: p.vendor || '', img: p.image || (p.featured_image && p.featured_image.url) || '',
          pr: parseFloat(p.price) || 0, px: parseFloat(p.price_max) || parseFloat(p.price) || 0, nv: vs.length,
          cp: one && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? parseFloat(p.compare_at_price_max) : 0,
          vid: one && okv ? okv.id : null, av: p.available !== false, url: p.url };
      });
    }).catch(function () { return []; });
  }

  /* ---------- Store answers (only from settings; nothing invented) ---------- */
  function contactLines() {
    var c = [];
    if (cfg.whatsapp) c.push('WhatsApp / phone: ' + cfg.whatsapp);
    if (cfg.email) c.push('Email: ' + cfg.email);
    return c;
  }
  function withContact(text) { var c = contactLines(); return c.length ? text + '\n\n' + c.join('\n') : text; }
  function has(n, re) { return re.test(n); }

  function storeAnswer(n) {
    var words = n.trim().split(' ').length;
    if (has(n, /^\s*(hi|hii+|hello|hey|salam|salaam|assalam\w*|aoa|hola|good (morning|evening|afternoon))\b/) && words <= 4)
      return { text: 'Hello! 👋 I can help you find skin care, vitamins, baby and personal care, health devices and more. What are you looking for?', chips: STARTERS };
    if (has(n, /\b(thank|thanks|thx|shukran|jazak)\w*/) && words <= 6) return { text: 'You\'re welcome! Anything else I can help with?', chips: STARTERS.slice(0, 3) };
    // "what can you do" / "how can you help" — asked constantly, and it deserves
    // a real answer. Guarded so "can you help me find a serum" still shops.
    if ((has(n, /\b(how|what)\s+((can|do|does|will|would)\s+)?(you|u)\s+((can|could)\s+)?(help|assist|do)\b/)
         || has(n, /\b(who|what)\s+(are|r)\s+(you|u)\b/)
         || (words <= 5 && has(n, /\b(can|could)\s+(you|u)\s+help\b/)))
        && !has(n, /\b(find|looking|search|need|want|buy|order|deliver|delivery|return|refund|price|cheap)\b/))
      return { text: 'I can help you:\n- find products by category, brand, concern or budget\n- compare a few options and add one to your cart\n- check what is in stock and what a product costs\n- answer questions about delivery, payment and returns\n\nTry something like "serum for dry skin", "vitamin D under 100" or "blood pressure monitor" — or pick a topic below.', chips: STARTERS.slice(0, 6) };
    if (has(n, /^\s*(bye|goodbye|ok bye|see you)\b/)) return { text: 'Thanks for visiting ' + (cfg.shopName || 'our store') + '. Have a great workout! 💪' };
    if (has(n, /\b(who are you|what are you|are you (a )?(bot|robot|human|real|ai)|your name)\b/))
      return { text: 'I\'m the ' + (cfg.agentName || 'AI Shop Assistant') + ' for ' + (cfg.shopName || 'this store') + '. I can search our catalog, show prices and add items to your cart, and answer common questions. For anything about a specific order, our team can help directly.' };
    if (has(n, /\b(human|real person|agent|staff|talk to (someone|a person)|contact|call you|phone number|whatsapp|email)\b/))
      return { text: withContact('You can reach our team here:') };
    if (has(n, /\b(address|location|located|where are you|where is (your|the) (shop|store)|store location|visit (the |your )?(shop|store)|directions)\b|العنوان|الفرع|وين موقعكم|اين موقعكم/))
      return { text: cfg.address ? withContact('Our store: ' + cfg.address) : withContact('Please contact our team for store location details:') };
    if (has(n, /\b(open|opening|close|closing|timing|timings|hours|working hours)\b|دوام|ساعات العمل|متى تفتحون/))
      return { text: cfg.hours ? cfg.hours : withContact('For our current opening hours, please contact the team:') };
    if (has(n, /\b(payment|pay|cash on delivery|cod|card|visa|mastercard|apple pay|tabby|tamara|installments?)\b|الدفع|ادفع|أدفع|الدفع عند الاستلام/))
      return { text: cfg.payment ? cfg.payment : withContact('Available payment methods are shown at checkout. For anything specific, contact our team:') };
    if (has(n, /\b(deliver|delivery|shipping|ship|courier|same day|next day|dispatch)\b|توصيل|التوصيل|شحن|الشحن/))
      return { text: cfg.delivery ? withContact(cfg.delivery) : withContact('Delivery times and charges depend on your area. Our team can confirm for you:') };
    if (has(n, /\b(return|refund|exchange|damaged|wrong item|broken)\b|استرجاع|الاسترجاع|ارجاع|إرجاع|استبدال|استرداد/))
      return { text: cfg.returns ? withContact(cfg.returns) : withContact('For returns, refunds or exchanges, please contact our team with your order number:') };
    if (has(n, /\b(track|tracking|order status|where is my order|my order|order number|cancel (my )?order)\b/))
      return { text: withContact('I can\'t look up orders from this chat. Please send your order number to our team:') };
    if (has(n, /\b(original|authentic|genuine|fake|real product|expiry|expiration|batch)\b/))
      return { text: withContact('For authenticity, batch or expiry details on a specific product, our team can confirm directly:') };
    if (has(n, /\b(brands?|which brand|what brand|stock brand)\b/) && !vendorsIn(n).length) {
      var bl = brandList();
      if (bl.length) return { text: 'We stock ' + bl.length + ' brands, including:\n' + bl.slice(0, 14).join(', ') + '.\n\nTell me a brand name and I\'ll show you what we have.', chips: STARTERS.slice(0, 4) };
    }
    if (has(n, /\b(halal|haram|pork|gelatin|gelatine|alcohol)\b|حلال|حرام|جيلاتين/))
      return { text: withContact('For halal certification or exact ingredients on a specific product, please check the label on the product page or ask our team — they can confirm for that item:') };
    if (has(n, /\b(coupon|promo code|discount code|voucher)\b/))
      return { text: 'I don\'t have coupon codes, but I can show you products that are on sale right now.', chips: [], action: { label: '🏷️ Show products on sale', q: 'show products on sale' } };
    return null;
  }

  function brandList() {
    if (!catalog || !catalog.length) return [];
    var seen = {};
    catalog.forEach(function (p) { if (p.vd) seen[p.vd] = (seen[p.vd] || 0) + 1; });
    return Object.keys(seen).sort(function (a, b) { return seen[b] - seen[a]; });
  }

  /* ---------- General supplement knowledge (short, neutral, not medical advice) ---------- */
  var KB = [
    { re: /\b(whey|concentrate)\b.*\b(isolate)\b|\b(isolate)\b.*\b(whey|concentrate)\b|difference.*(whey|isolate)/, intent: 'sports',
      text: 'Whey concentrate and whey isolate both come from milk. Isolate is filtered further, so it usually has a higher protein percentage and less fat and lactose, which can suit people sensitive to lactose. Concentrate is typically more affordable. Both are popular for everyday protein intake.' },
    { re: /\b(what is|what are|benefits? of|why (take|use)|does|is)\b.*\bcreatine\b|\bcreatine\b.*\b(safe|work|good|benefit|do|loading|water)\b/, intent: 'sports',
      text: 'Creatine is one of the most researched sports supplements. It\'s mainly used to support strength and power in short, intense training. Creatine monohydrate is the most common form. Follow the directions on the label, drink enough water, and check with your doctor first if you have kidney issues or other health conditions.' },
    { re: /\b(what is|what are|benefits? of|why|does|is|how)\b.*\b(pre ?workout|pre-workout|preworkout)\b|\b(pre ?workout|pre-workout|preworkout)\b.*\b(safe|work|good|do|side)\b/, intent: 'sports',
      text: 'Pre-workouts are taken before training for energy and focus. Many contain caffeine plus ingredients like citrulline or beta-alanine (which can cause a harmless tingling feeling). Check the caffeine amount on the label, avoid taking it late in the day, and speak to a doctor first if you\'re sensitive to caffeine or have heart or blood pressure concerns.' },
    { re: /\b(what is|what are|benefits? of|why|does|is|who)\b.*\b(mass gainer|weight gainer|gainer)\b|\b(gainer)\b.*\b(safe|work|good|fat|vs|or)\b/, intent: 'sports',
      text: 'Mass gainers combine protein with a lot of carbohydrates to add calories. They\'re mainly for people who struggle to eat enough to gain weight. If you only want more protein without many extra calories, a regular whey protein is usually a better fit.' },
    { re: /\b(what is|what are|benefits? of|why|does|do|is)\b.*\b(bcaa|eaa|amino)\b|\b(bcaa|eaa)\b.*\b(vs|or|work|good|need)\b/, intent: 'sports',
      text: 'BCAAs and EAAs are amino acids, the building blocks of protein. EAAs include all essential amino acids, while BCAAs are three of them. If you already get enough protein from food or shakes, the extra benefit tends to be smaller, but some people like them during training.' },
    { re: /\b(what is|what are|do|does|is|are)\b.*\b(fat burner|fat burners|burner|l ?carnitine|cla)\b|\b(fat burner|burners?)\b.*\b(work|safe|good)\b/, intent: 'sports',
      text: 'Fat burners can support a fat-loss plan, but they don\'t replace a calorie deficit, good sleep and training. Many contain stimulants like caffeine. Follow the label and check with a doctor first if you have heart, blood pressure or thyroid concerns, or take medication.' },
    { re: /\b(vegan|plant)\b.*\b(protein)\b.*\b(good|vs|or|what|better|work)\b|\b(what is|is)\b.*\b(vegan|plant) protein\b/, intent: 'sports',
      text: 'Plant proteins usually come from pea, rice, soy or a blend. Blends help give a more complete amino acid profile. They\'re a good option if you\'re vegan or avoid dairy.' },
    { re: /\b(how much|how many|when (should|to|do)|best time|timing|how (to|do i|should i) (take|use|mix))\b.*\b(protein|whey|creatine|scoop|scoops|shake|gainer|pre ?workout|bcaa)\b/, intent: null,
      text: 'The right amount and timing depends on the product and on you, so please follow the directions on the product label. For personal advice (especially if you have a health condition, take medication, or are pregnant or under 18), check with a doctor or registered dietitian.' },
    { re: /\b(side effects?|safe|dangerous|harmful|pregnan\w*|breastfeeding|kidney|liver|blood pressure|heart|diabet\w*|allerg\w*|medication|medicine|teen|teenager|under 18|kids?|child)\b/, intent: null,
      text: 'I can\'t give medical advice. Supplements affect people differently, so please read the product label and speak with a doctor or pharmacist before using them, especially if you have a health condition, allergies, take medication, or are pregnant or under 18.' },
    { re: /\b(multivitamin|vitamin|omega|fish oil|magnesium|zinc)\b.*\b(what|why|good|benefit|need|should)\b|\b(what|why|should)\b.*\b(multivitamin|vitamin|omega|fish oil|magnesium|zinc)\b/, intent: 'vitamins',
      text: 'Vitamins and minerals help fill gaps in your diet. Which ones make sense depends on what you eat and your health, so a doctor or blood test is the best way to know what you actually need. I can show you what we stock.' },
    { re: /\b(casein)\b.*\b(vs|or|versus|difference|what|better|when|why)\b|\b(vs|or|versus|difference|what is|what are)\b.*\b(casein)\b/, intent: 'sports',
      text: 'Casein and whey are both milk proteins. Whey digests quickly, so it suits the time around training. Casein digests slowly over several hours, which is why many people take it before bed or between meals. Plenty of people use both.' },
    { re: /\b(collagen)\b/, intent: 'vitamins',
      text: 'Collagen is a protein found in skin, hair, nails, joints and connective tissue. People take it hoping to support those areas. Evidence is strongest for joint comfort and skin, and results vary between individuals. It is low in some amino acids, so it does not replace whey or another complete protein for muscle building.' },
    { re: /\b(beef protein|carnivor)\b|\bbeef\b.*\b(protein|good|vs|why)\b/, intent: 'sports',
      text: 'Beef protein is made from beef and contains no dairy or lactose, so it suits people who react badly to whey. The protein content per scoop is usually comparable, though the taste is different.' },
    { re: /\b(carb|carbs|carbohydrate|carbohydrates|maltodextrin|dextrose|karbolyn|vitargo|intra ?workout)\b/, intent: 'sports',
      text: 'Carbohydrate supplements give fast fuel around training. They are most useful for long or very intense sessions, for endurance work, or when you are trying to gain weight. If your sessions are short, food usually covers it.' },
    { re: /\b(sleep|melatonin|zma|insomnia)\b/, intent: 'vitamins',
      text: 'Sleep is when most recovery happens. Some people use magnesium, ZMA or melatonin to help wind down. Melatonin in particular is best used occasionally rather than every night, and it is worth speaking to a doctor or pharmacist first, especially if you take other medication.' },
    { re: /\b(beginner|beginners|starting|start(ed|ing)? (the )?gym|new to (the )?gym|first time|what should i (take|buy|start))\b/, intent: 'sports',
      text: 'If you are starting out, keep it simple. A whey protein helps you reach your daily protein target, and creatine monohydrate is the best-researched option for strength. Everything else is optional. Train consistently, eat enough, and sleep well — those matter far more than any supplement.' },
    { re: /\b(lactose|dairy free|stomach|bloat|bloating|digest|digestion|gas)\b/, intent: 'sports',
      text: 'If whey upsets your stomach, the usual culprit is lactose. A whey isolate contains less lactose than a concentrate, and plant protein or beef protein contain none at all. Starting with a smaller serving also helps.' },
    { re: /\b(sugar free|no sugar|low carb|keto|diet friendly|calorie)\b.*\b(protein|shake|option)\b|\b(protein|whey)\b.*\b(sugar free|no sugar|low carb|keto)\b/, intent: 'sports',
      text: 'For a lower-sugar, lower-carb option, look at a whey isolate or a lean/diet protein rather than a mass gainer. The nutrition panel on each product page gives the exact carb and sugar per serving.' },
    { re: /\b(which|what|best|choose|choosing|pick|recommend)\b.*\b(protein|whey)\b.*\b(best|good|should|for me|choose)\b|\bhow (do i|to) (choose|pick)\b/, intent: 'sports',
      text: 'When choosing a protein, look at three things: protein per serving, how it fits your budget per serving, and whether you tolerate lactose. Isolates are leaner and lower in lactose, concentrates are better value. Flavour matters more than people expect — you will only use it if you enjoy it.' }
  ];
  function knowledge(n) {
    for (var i = 0; i < KB.length; i++) if (KB[i].re.test(n)) return KB[i];
    return null;
  }

  var AR_RE = /[؀-ۿ]/;
  var AR_STORE_RE = /(توصيل|التوصيل|شحن|الشحن|الدفع|ادفع|أدفع|استرجاع|الاسترجاع|ارجاع|إرجاع|استبدال|طلبي|الطلب|تتبع|دوام|ساعات العمل|العنوان|الفرع|فرعكم|حلال|واتساب|ايميل|رقمكم)/;
  var AR_SHOP_RE = /(لديكم|عندكم|أريد|اريد|ابغى|أبغى|بدي|ودي|بكم|كم سعر|السعر|أرخص|ارخص|أفضل|افضل|عروض|خصم|متوفر|منتج|ماركة|ماركات|نكهات|احتاج|أحتاج|ابحث|أبحث|اشتري|أشتري|انصحني|انصحوني|وش عندكم)/;
  var AR_QUESTION_RE = /(^|\s)(ما|ماذا|ماهو|كيف|متى|أين|اين|هل|لماذا|ليش|شنو|وش)(\s|$)|؟\s*$/;
  var AR_SMALLTALK_RE = /^\s*(مرحبا|مرحبًا|أهلا|اهلا|السلام عليكم|سلام|هاي|شكرا|شكرًا|مشكور|تمام|أوك|اوك|باي|مع السلامة)[\s!.,؟]*$/;
  var QUESTION_RE = /^\s*(what|whats|why|how|when|where|who|which|is|are|does|do|did|can|could|should|would|will|explain|tell me about|difference|meaning)\b|\?\s*$/;
  var SHOP_RE = /\b(do you (have|sell|stock|carry)|got any|have you got|show|recommend|recommendation|suggest|buy|purchase|order|need|want|looking for|find|search|get me|best|top|popular|price|prices|cost|how much is|cheap|cheapest|affordable|under|below|budget|in stock|stock|available|options?|products?|brands?|flavou?rs?|sizes?|sale|offer|deal|new arrivals?|latest)\b/;
  /* ---------- Rendering ---------- */
  function money(amount) {
    var fmt = cfg.moneyFormat || '{{amount}}';
    var fixed = Number(amount || 0).toFixed(2);
    var parts = fixed.split('.');
    function group(sep, dec, decimals) {
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return decimals ? i + dec + parts[1] : i;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      if (k === 'amount_no_decimals') return group(',', '.', false);
      if (k === 'amount_with_comma_separator') return group('.', ',', true);
      if (k === 'amount_no_decimals_with_comma_separator') return group('.', ',', false);
      if (k === 'amount_with_apostrophe_separator') return group("'", '.', true);
      return group(',', '.', true);
    });
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  /* ---------- Chat history: survives refresh, new tabs and closing the browser (24h) ---------- */
  var HKEY = 'aisa_history_v3';
  var HKEEP = 24 * 60 * 60 * 1000;
  var history = [];
  try {
    var saved = JSON.parse(localStorage.getItem(HKEY) || 'null');
    if (saved && saved.t && (Date.now() - saved.t) < HKEEP && Array.isArray(saved.h)) history = saved.h;
  } catch (e) { history = []; }
  function saveHistory() {
    if (history.length > 120) history = history.slice(-120);
    try { localStorage.setItem(HKEY, JSON.stringify({ t: Date.now(), h: history })); } catch (e) {}
  }
  function add(entry) { history.push(entry); saveHistory(); return render(entry, true); }
  function remember(entry) { history.push(entry); saveHistory(); }
  function render(entry, animate) {
    var node;
    if (entry.k === 'm') {
      node = el('div', 'aisa-msg ' + entry.w);
      var tail = function () {
        if (!entry.link) return;
        node.appendChild(document.createTextNode(' '));
        var a = el('a', '', entry.link.t); a.href = entry.link.h; a.target = '_blank'; a.rel = 'noopener';
        node.appendChild(a);
      };
      // A new answer is revealed as it is "written"; restored history is not.
      if (animate && entry.w === 'bot' && entry.t && entry.t.length > 16) {
        node.classList.add('aisa-streaming');
        log.appendChild(node);
        node.typed = typeOut(node, entry.t, null, !entry.r).then(tail);
        return node;
      }
      if (entry.r) node.innerHTML = richHtml(entry.t); else node.textContent = entry.t;
      tail();
      log.appendChild(node);
    } else if (entry.k === 'l') {
      node = el('div', 'aisa-label', entry.t); log.appendChild(node);
    } else if (entry.k === 'c') {
      node = renderChips(entry.ids, entry.inline);
    } else if (entry.k === 'p') {
      node = renderCards(entry.items);
    } else if (entry.k === 'a') {
      node = el('div', 'aisa-chips inline');
      var ab = el('button', 'aisa-chip aisa-chip-action', entry.label); ab.type = 'button';
      ab.addEventListener('click', function () { ask(entry.q); });
      node.appendChild(ab); log.appendChild(node);
    } else if (entry.k === 'q') {
      node = el('div', 'aisa-chips inline');
      entry.items.forEach(function (q) {
        var qb = el('button', 'aisa-chip', q); qb.type = 'button';
        qb.addEventListener('click', function () { ask(q); });
        node.appendChild(qb);
      });
      log.appendChild(node);
    } else if (entry.k === 'more') {
      node = el('div', 'aisa-chips inline');
      var mb = el('button', 'aisa-chip aisa-chip-action', entry.label); mb.type = 'button';
      if (entry.used) mb.disabled = true;
      mb.addEventListener('click', function () {
        if (entry.used) return;
        entry.used = true; saveHistory(); mb.disabled = true;
        cards(entry.items);
      });
      node.appendChild(mb); log.appendChild(node);
    }
    scrollDown();
    return node;
  }
  function say(text, who, link) { return add({ k: 'm', w: who || 'bot', t: text, link: link }); }
  function sayRich(text) { return add({ k: 'm', w: 'bot', t: text, r: true }); }

  // The agent's reply is untrusted text: escape everything first, then allow only
  // bold, links and bullets back in.
  function richHtml(text) {
    var out = String(text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    out = out.replace(/\[([^\]\n]{1,120})\]\((https?:\/\/[^\s)]+|\/(?!\/)[^\s)]*)\)/g,
      function (_, t, u) { return '<a href="' + u + '" target="_blank" rel="noopener">' + t + '</a>'; });
    out = out.replace(/(^|[\s(])((?:https?:\/\/)[^\s<)]+)/g,
      function (m, pre, u) { return pre + '<a href="' + u + '" target="_blank" rel="noopener">' + u + '</a>'; });
    out = out.replace(/\*\*([^*\n]{1,200})\*\*/g, '<strong>$1</strong>');
    out = out.replace(/^\s*[-*]\s+/gm, '• ');
    out = out.replace(/^\s*#{1,6}\s*/gm, '');
    return out;
  }
  function typing() { var t = el('div', 'aisa-msg bot aisa-typing'); t.innerHTML = '<b></b><b></b><b></b>'; log.appendChild(t); scrollDown(); return t; }
  function chips(ids, inline) { return add({ k: 'c', ids: ids, inline: !!inline }); }
  function qchips(list) { return add({ k: 'q', items: list }); }
  function moreBtn(items) { return add({ k: 'more', items: items, label: 'Show ' + items.length + ' more' }); }
  function cards(list) {
    var items = list.map(function (p) { return { t: p.t, h: p.h, vd: p.vd, img: p.img, pr: p.pr, px: p.px, nv: p.nv, cp: p.cp, vid: p.vid, av: p.av, url: p.url }; });
    return add({ k: 'p', items: items });
  }

  function renderChips(ids, inline) {
    var wrap = el('div', 'aisa-chips' + (inline ? ' inline' : ''));
    ids.forEach(function (id) {
      var it = INTENTS.filter(function (x) { return x.id === id; })[0];
      if (!it) return;
      var b = el('button', 'aisa-chip');
      b.type = 'button';
      b.appendChild(el('span', '', it.icon));
      b.appendChild(el('span', '', it.label));
      b.addEventListener('click', function () { ask(it.label); });
      wrap.appendChild(b);
    });
    log.appendChild(wrap);
    return wrap;
  }

  function productUrl(p) { return p.url || (ROOT + 'products/' + p.h); }
  function imgSrc(src) {
    if (!src || src.indexOf('data:') === 0) return src || '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  }

  /* A flavour/size dropdown for the card. The first in-stock option is selected
     so "Add to cart" works in one tap, but the shopper can see and change it —
     the widget never adds a variant they haven't been shown. */
  var PICK_CSS = 'display:block;width:100%;max-width:260px;margin:6px 0 2px;padding:6px 26px 6px 8px;font:inherit;font-size:13px;line-height:1.3;color:inherit;background:#fff;border:1px solid rgba(0,0,0,.2);border-radius:8px;cursor:pointer';
  function variantPicker(p, priceEl) {
    var sel = document.createElement('select');
    sel.className = 'aisa-variant';
    sel.style.cssText = PICK_CSS;
    sel.setAttribute('aria-label', 'Choose an option for ' + p.t);
    var current = null;
    p.vs.forEach(function (v) {
      var o = document.createElement('option');
      o.value = String(v.i);
      o.textContent = v.n + (v.a ? '' : ' - sold out');
      o.disabled = !v.a;
      sel.appendChild(o);
      if (!current && v.a) current = v;
    });
    if (current) sel.value = String(current.i);
    function showPrice() {
      if (!priceEl || !current || !(current.p > 0)) return;
      priceEl.textContent = money(current.p);
      priceEl.classList.remove('aisa-price-none');
    }
    sel.addEventListener('change', function () {
      for (var i = 0; i < p.vs.length; i++) if (String(p.vs[i].i) === sel.value) current = p.vs[i];
      showPrice();
    });
    showPrice();
    return { node: sel, chosen: function () { return current; } };
  }

  function renderCards(list) {
    var wrap = el('div', 'aisa-products');
    list.forEach(function (p) {
      p = freshen(p);                 // re-price cards restored from an older conversation
      var card = el('div', 'aisa-card');
      var link = el('a', 'aisa-card-media'); link.href = productUrl(p); link.target = '_blank'; link.rel = 'noopener'; link.tabIndex = -1; link.setAttribute('aria-hidden', 'true');
      if (p.img) { var img = document.createElement('img'); img.src = imgSrc(p.img); img.alt = ''; img.loading = 'lazy'; img.width = 76; img.height = 76; link.appendChild(img); }
      card.appendChild(link);

      var info = el('div', 'aisa-card-info');
      if (p.vd) info.appendChild(el('div', 'aisa-card-meta', p.vd));
      var title = el('a', 'aisa-card-title', p.t); title.href = productUrl(p); title.target = '_blank'; title.rel = 'noopener';
      info.appendChild(title);

      // Price: never invent one. "From" when variants differ, nothing when unset.
      var priceText;
      if (!(p.pr > 0)) priceText = 'Price not listed';
      else if (p.px > p.pr) priceText = 'From ' + money(p.pr);
      else priceText = money(p.pr);
      var price = el('div', 'aisa-price' + (p.cp ? ' on-sale' : '') + (p.pr > 0 ? '' : ' aisa-price-none'), priceText);
      if (p.cp) { var s = el('s', '', money(p.cp)); price.appendChild(s); }
      info.appendChild(price);
      if (!p.av) info.appendChild(el('div', 'aisa-soldout', 'Sold out'));

      // Flavours and sizes are picked right here, so "Add to cart" still works
      // without the widget choosing one for the shopper.
      var picker = (p.av && p.nv > 1 && p.vs && p.vs.length > 1) ? variantPicker(p, price) : null;
      if (picker) info.appendChild(picker.node);

      var actions = el('div', 'aisa-card-actions');
      var view = el('a', 'aisa-btn', 'View product'); view.href = productUrl(p); view.target = '_blank'; view.rel = 'noopener';
      actions.appendChild(view);
      var pick0 = picker ? picker.chosen() : null;
      var vid = pick0 ? pick0.i : p.vid;
      var priced = pick0 ? pick0.p > 0 : p.pr > 0;
      if (p.av && vid && priced) {
        // Never a one-tap add without a published price.
        var addBtn = el('button', 'aisa-btn solid', 'Add to cart'); addBtn.type = 'button';
        addBtn.addEventListener('click', function () {
          var now = picker ? picker.chosen() : null;
          addToCart(p, addBtn, now ? now.i : p.vid, now ? now.n : '');
        });
        actions.appendChild(addBtn);
      } else if (p.av && p.nv > 1) {
        var choose = el('a', 'aisa-btn solid', 'Choose options');
        choose.href = productUrl(p); choose.target = '_blank'; choose.rel = 'noopener';
        actions.appendChild(choose);
      }
      info.appendChild(actions);
      card.appendChild(info);
      wrap.appendChild(card);
    });
    log.appendChild(wrap);
    return wrap;
  }

  /* ---------- Add to cart: same flow as the theme's own product form ---------- */
  function addToCart(p, btn, vid, vname) {
    vid = vid || p.vid;
    if (!vid) { window.open(productUrl(p), '_blank', 'noopener'); return; }
    btn.disabled = true; btn.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && drawer.dataset.cartType !== 'page' && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', 1);
    if (useDrawer) {
      fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var url = (window.routes && window.routes.cart_add_url) || (ROOT + 'cart/add');
    fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) {
        return r.text().then(function (raw) {
          var data = null;
          try { data = JSON.parse(raw); } catch (e) {}
          if (!data) throw new Error(r.ok ? 'the store sent an unexpected response.' : 'the store is busy right now, please try again.');
          if (!r.ok && !data.description && !data.message) throw new Error('the store is busy right now, please try again.');
          return data;
        });
      })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'This item could not be added.');
        btn.textContent = 'Added ✓';
        say('Added "' + p.t + (vname ? ' - ' + vname : '') + '" to your cart.', 'bot', { t: 'View cart', h: cfg.cartUrl || (ROOT + 'cart') });
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ai-shop-assistant', productVariantId: vid, cartData: res });
          }
        } catch (e) {}
        if (useDrawer && res.sections) {
          try {
            hide(true);
            drawer.classList.remove('is-empty', 'wt-cart--empty');
            var closed = !document.body.classList.contains('page-overlay-cart-on');
            drawer.renderContents(res, closed);
          } catch (e) { refreshBubble(); }
        } else {
          refreshBubble();
        }
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to cart'; }, 2500);
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = 'Add to cart';
        say('Sorry, that item couldn\'t be added: ' + (err && err.message ? err.message : 'please try again.') + ' You can also open the product page to choose an option.', 'bot', { t: 'View product', h: productUrl(p) });
      });
  }
  function refreshBubble() {
    fetch(ROOT + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
      var target = document.getElementById('cart-icon-bubble');
      if (!target || !d['cart-icon-bubble']) return;
      var html = new DOMParser().parseFromString(d['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (html) target.innerHTML = html.innerHTML;
    }).catch(function () {});
  }

  /* ---------- PangeaMind agent ---------- */
  function agentReady() { return !!(cfg.aiUrl && cfg.aiKey); }

  // The reply field name varies between agent platforms, so look through the usual ones.
  function pickText(d) {
    if (d == null) return '';
    if (typeof d === 'string') return d;
    var keys = ['response','reply','message','answer','text','content','output','result','data'];
    for (var i = 0; i < keys.length; i++) {
      var v = d[keys[i]];
      if (typeof v === 'string' && v.trim()) return v;
    }
    if (d.choices && d.choices[0]) {
      var c = d.choices[0];
      if (c.message && typeof c.message.content === 'string') return c.message.content;
      if (typeof c.text === 'string') return c.text;
    }
    for (var j = 0; j < keys.length; j++) {
      var o = d[keys[j]];
      if (o && typeof o === 'object') { var inner = pickText(o); if (inner) return inner; }
    }
    return '';
  }

  // Last few turns, so the agent remembers the conversation. Kept short on
  // purpose: history is re-sent with every message, so it is the main cost driver.
  var HIST_TURNS = 6, HIST_CHARS = 500;
  function agentHistory() {
    var out = [];
    for (var i = 0; i < history.length; i++) {
      var e = history[i];
      if (e.k === 'm' && e.t) out.push({ role: e.w === 'user' ? 'user' : 'assistant', content: String(e.t).slice(0, HIST_CHARS) });
    }
    if (out.length && out[out.length - 1].role === 'user') out.pop();  // current turn is sent separately
    return out.slice(-HIST_TURNS);
  }

  // Server-sent-events text so far. The whole buffer is re-read each time, so a
  // half-arrived JSON line is simply skipped and picked up on the next chunk.
  function sseText(raw) {
    var out = '', lines = raw.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      if (l.indexOf('data:') !== 0) continue;
      var d = l.slice(5).replace(/^ /, '');
      if (!d || d === '[DONE]') continue;
      if (d.charAt(0) === '{' || d.charAt(0) === '[') {
        try {
          var j = JSON.parse(d), piece = null;
          if (j.delta && typeof j.delta === 'object') piece = j.delta.content || j.delta.text;
          if (piece == null && j.choices && j.choices[0]) {
            var c0 = j.choices[0];
            piece = (c0.delta && (c0.delta.content || c0.delta.text)) || c0.text;
          }
          if (piece == null) piece = pickText(j);
          if (typeof piece === 'string') out += piece;
        } catch (e) {}
      } else {
        out += (out ? '\n' : '') + d;     // SSE joins consecutive data: lines with a newline
      }
    }
    return out;
  }

  // Asks the agent. onDelta(textSoFar) fires while the reply streams in; if the
  // server answers in one piece instead, onDelta never fires and the caller
  // types the text out itself.
  var agentNoStream = false;     // set once the agent tells us it can't stream
  function askAgent(text, onDelta, noStreamFlag) {
    if (!agentReady()) return Promise.resolve(null);
    if (agentNoStream) noStreamFlag = true;
    var ctl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var ms = (parseInt(cfg.aiTimeout, 10) || 25) * 1000;
    var timer = null, streamed = '';
    // The timeout is for silence, not for length: every chunk that arrives
    // restarts it, so a long reply is never cut off mid-sentence.
    function arm() { clearTimeout(timer); timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms); }
    arm();
    var payload = { message: text, conversation_history: agentHistory() };
    if (!noStreamFlag) payload.stream = true;
    var opts = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream, application/json',
        'Authorization': 'Bearer ' + cfg.aiKey
      },
      body: JSON.stringify(payload)
    };
    if (ctl) opts.signal = ctl.signal;

    function whole(raw) {
      var t = '';
      try { t = pickText(JSON.parse(raw)); } catch (e) { t = raw; }
      return String(t || '').trim() || null;
    }

    return fetch(cfg.aiUrl, opts)
      .then(function (r) {
        // Some APIs reject an unknown "stream" field: retry once without it.
        if (r.status >= 400 && r.status < 500 && !noStreamFlag) {
          clearTimeout(timer);
          agentNoStream = true;       // remember it, so every later message goes straight through
          return askAgent(text, onDelta, true);
        }
        if (!r.ok) throw new Error('agent ' + r.status);
        var ct = String((r.headers && r.headers.get && r.headers.get('content-type')) || '').toLowerCase();
        if (!r.body || typeof r.body.getReader !== 'function' || typeof TextDecoder === 'undefined') {
          return r.text().then(function (raw) { clearTimeout(timer); return whole(raw); });
        }
        var reader = r.body.getReader(), dec = new TextDecoder();
        var raw = '', shown = '', isSse = ct.indexOf('event-stream') !== -1;
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) {
              clearTimeout(timer);
              return isSse ? (shown.trim() || null) : whole(raw);
            }
            arm();
            raw += dec.decode(res.value, { stream: true });
            if (!isSse && /(^|\n)data:/.test(raw)) isSse = true;   // streaming without the header
            if (isSse) {
              var t = sseText(raw);
              if (t && t !== shown) { shown = t; streamed = t; if (onDelta) onDelta(t); }
            }
            return pump();
          });
        }
        return pump();
      })
      .catch(function (e) {
        clearTimeout(timer);
        if (window.console) console.warn('[AI Shop Assistant]', e);
        return streamed.trim() || null;   // a cut-off stream keeps what the shopper already read
      });
  }

  // Reveals a reply that arrived all at once, so it reads like it is being typed.
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function typeOut(node, text, live, plain) {
    function put(t, final) {
      if (plain) node.textContent = t;
      else node.innerHTML = richHtml(final ? t : partial(t));
    }
    return new Promise(function (done) {
      if (REDUCED && REDUCED.matches) { put(text, true); scrollDown(); return done(); }
      var i = 0, step = Math.max(2, Math.ceil(text.length / 90));
      var id = setInterval(function () {
        if (live && !live()) { clearInterval(id); return done(); }   // chat was reset mid-type
        i += step;
        // land on a word boundary, so it reads word by word rather than mid-word
        var sp = text.indexOf(' ', i);
        if (sp !== -1 && sp - i < 14) i = sp;
        if (i >= text.length) {
          clearInterval(id);
          node.classList.remove('aisa-streaming');
          put(text, true);
          scrollDown();
          return done();
        }
        put(text.slice(0, i));
        scrollDown();
      }, 18);
    });
  }
  // Hide a half-typed "**" so bold does not flash as literal asterisks.
  function partial(t) { return t.replace(/\*{1,2}$/, '').replace(/\[[^\]]*$/, ''); }

  /* ---------- Cards follow the agent's picks ----------
     The agent has live Shopify access and names the products it recommends.
     Those are the products to put on cards — not whatever the shopper's own
     words happen to match. Category words like "whey protein" are ignored,
     so only real product names become cards. */

  // Words that name a category rather than a product, gathered from the topics above.
  var CATEGORY_WORDS = (function () {
    var m = {};
    INTENTS.forEach(function (it) {
      it.words.concat(it.terms, it.types).forEach(function (w) {
        String(w).split(' ').forEach(function (x) { if (x.length > 2) m[x] = 1; });
      });
    });
    ['the','and','for','with','our','your','one','two','tablets','capsules','servings','powder','size','flavour','flavor'].forEach(function (x) { m[x] = 1; });
    return m;
  })();

  // Does this reply look like it names products at all? Checked before the
  // catalog is fetched, so a plain answer still costs no download.
  function mayNameProducts(reply) {
    return cfg.aiProducts !== false && /\*\*[^*\n]{3,120}\*\*/.test(String(reply));
  }

  function productsNamed(reply) {
    if (cfg.aiProducts === false || !catalog || !catalog.length) return null;
    var picked = [], seen = {};
    var re = /\*\*([^*\n]{3,120})\*\*/g, m, names = [];
    while ((m = re.exec(String(reply)))) names.push(m[1]);

    names.forEach(function (name) {
      var words = norm(name).trim().split(' ').filter(function (w) { return w.length > 2 && GENERIC.indexOf(w) === -1; });
      if (words.length < 2) return;                       // "creatine" alone is a category
      var best = null, bestScore = 0, ties = 0;
      for (var i = 0; i < catalog.length; i++) {
        var p = catalog[i], title = norm(p.t), hit = 0, distinct = 0;
        for (var j = 0; j < words.length; j++) {
          if (title.indexOf(' ' + words[j]) !== -1) { hit++; if (!CATEGORY_WORDS[words[j]]) distinct++; }
        }
        if (!distinct) continue;                          // matched only category words
        var score = hit / words.length;
        if (score > bestScore) { bestScore = score; best = p; ties = 1; }
        else if (score === bestScore && score > 0) ties++;
      }
      if (best && bestScore >= 0.6 && ties <= 2 && !seen[best.h]) { seen[best.h] = 1; picked.push(best); }
    });
    if (picked.length) return picked;

    // Nothing resolved to one product. If the agent named a category instead
    // ("**Creatine**"), show that category. Words like "delivery" score nothing
    // against any title, so they still produce no cards.
    if (names.length) {
      var pq = parse(names.join(' '));
      // Only when a real category was named. "Free delivery" or "our Dubai branch"
      // match no topic, so they never pull up products.
      if (pq.intents.length) {
        var r = search(pq);
        if (r.list.length) return r.list;
      }
    }
    return null;
  }

  // Fallback when the agent named nothing recognisable: match the shopper's own
  // words, but only when they are clearly shopping.
  function productsFor(text) {
    if (cfg.aiProducts === false) return null;
    if (!catalog || !catalog.length) return null;
    var pq = parse(text);
    var isQuestion = QUESTION_RE.test(' ' + text.toLowerCase().trim());
    var isShopping = SHOP_RE.test(pq.n) || pq.price.max != null || pq.price.min != null || pq.sort === 'sale' || pq.sort === 'new';
    var vendors = vendorsIn(pq.n);
    var looksLikeProductName = !isQuestion && pq.tokens.length > 0 && pq.tokens.length <= 5;
    if (!(isShopping || vendors.length || (pq.intents.length && !isQuestion) || looksLikeProductName)) return null;
    var r = search(pq);
    return r.list.length ? r.list : null;
  }

  /* ---------- Conversation ---------- */
  // Small talk never needs the catalog or a product search.
  var SMALLTALK_RE = /^(hi|hii+|hey|hello|yo|salam|salaam|assalam[ou]?\s?alaikum|thanks?|thank you|thx|ty|ok|okay|k|cool|nice|great|good|sure|yes|no|bye|goodbye)[\s!.,]*$/i;

  // Cheap pre-check, run before anything is fetched: could this message end up
  // showing product cards? If not, the 660-product catalog is never downloaded.
  function mayNeedProducts(text) {
    if (cfg.aiProducts === false) return false;
    var raw = String(text).trim();
    if (SMALLTALK_RE.test(raw)) return false;
    var low = ' ' + raw.toLowerCase() + ' ';
    if (AR_RE.test(raw)) {                       // Arabic message: decide on its own terms
      if (AR_SMALLTALK_RE.test(raw)) return false;
      if (intentWordIn(low)) return true;
      if (AR_STORE_RE.test(low)) return false;   // delivery, payment, returns, hours...
      if (AR_SHOP_RE.test(low)) return true;
      return !AR_QUESTION_RE.test(low);
    }
    if (SHOP_RE.test(low)) return true;
    if (/\b(aed|dhs|dhm|dirhams?)\b|\b\d{2,}\b/.test(low)) return true;      // budgets: "under 250"
    if (intentWordIn(low)) return true;
    if (!QUESTION_RE.test(low)) return true;    // a bare category or product name
    return false;                               // "do you deliver?", "what are your hours?"
  }

  // Word-start matching, so "deliver" does not count as "liver".
  function intentWordIn(low) {
    for (var i = 0; i < INTENTS.length; i++) {
      var it = INTENTS[i];
      for (var j = 0; j < it.words.length; j++) if (low.indexOf(' ' + it.words[j]) !== -1) return true;
      for (var k = 0; k < it.terms.length; k++) if (low.indexOf(' ' + it.terms[k]) !== -1) return true;
    }
    return false;
  }

  // Every message is a turn. Starting a new chat or closing bumps the counter,
  // so a reply that is still arriving from the previous turn is dropped instead
  // of landing in the fresh conversation.
  var turn = 0;
  function endTurn() { turn++; setBusy(false); }

  var busy = false;
  function setBusy(v) {
    busy = v;
    if (sendBtn) sendBtn.disabled = v;
    input.setAttribute('aria-busy', v ? 'true' : 'false');
  }
  // Pressing send while the last answer is still coming does nothing, so say so.
  var nudgeTimer = null;
  function nudge() {
    var box = root.querySelector('.aisa-input');
    if (!box) return;
    box.classList.remove('aisa-nudge');
    void box.offsetWidth;
    box.classList.add('aisa-nudge');
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function () { box.classList.remove('aisa-nudge'); }, 600);
  }

  function ask(text) {
    text = String(text || '').trim();
    if (!text) return;
    if (busy) { nudge(); return; }              // one request at a time: no double sends
    var myTurn = ++turn;
    function live() { return myTurn === turn; }
    setBusy(true);
    say(text, 'user');
    input.value = '';
    var t = typing();

    // The reply streams into this bubble as it arrives.
    var bubble = null;
    function onDelta(soFar) {
      if (!live()) return;
      if (!bubble) {
        if (t.parentNode) t.remove();
        bubble = el('div', 'aisa-msg bot aisa-streaming');
        log.appendChild(bubble);
      }
      bubble.innerHTML = richHtml(partial(soFar));
      scrollDown();
    }
    function paint(list) {
      if (!list || !list.length) return;
      cards(list.slice(0, MAX));
      if (list.length > MAX) moreBtn(list.slice(MAX, MAX + 6));
    }
    // Cards for the agent's answer: its own named picks first, the shopper's
    // words only as a fallback. The catalog is fetched here if it is needed.
    function showCards(aiText) {
      if (cfg.aiProducts === false) return Promise.resolve();
      if (catalog && catalog.length) { paint(productsNamed(aiText) || productsFor(text)); return Promise.resolve(); }
      if (!mayNameProducts(aiText) && !mayNeedProducts(text)) return Promise.resolve();
      return loadCatalog().then(function () { paint(productsNamed(aiText) || productsFor(text)); });
    }

    // The agent call and the catalog load run side by side, and the catalog is
    // only fetched when this message could actually produce product cards.
    var reply = agentReady() ? askAgent(text, onDelta) : Promise.resolve(null);
    var cat = (!agentReady() || mayNeedProducts(text)) ? loadCatalog() : Promise.resolve(null);

    Promise.all([reply, cat])
      .then(function (r) {
        if (!live()) return null;
        var aiText = r[0];
        if (aiText) {
          if (t.parentNode) t.remove();
          if (bubble) {                       // streamed live: just settle the final text
            bubble.classList.remove('aisa-streaming');
            if (!live()) return null;
            bubble.innerHTML = richHtml(aiText);
            remember({ k: 'm', w: 'bot', t: aiText, r: true });
            return showCards(aiText).then(function () { return null; });
          }
          bubble = el('div', 'aisa-msg bot aisa-streaming');   // arrived whole: type it out
          log.appendChild(bubble);
          return typeOut(bubble, aiText, live).then(function () {
            if (!live()) return;
            remember({ k: 'm', w: 'bot', t: aiText, r: true });
            return showCards(aiText);
          }).then(function () { return null; });
        }
        if (bubble && bubble.parentNode) bubble.remove();
        // Agent off, slow or failed: the built-in answers take over, and they need the catalog.
        return loadCatalog().then(function () { return respond(text); });
      })
      .then(function (res) {
        if (!res || !live()) return;
        t.remove();
        var said = res.text ? say(res.text) : null;
        var rest = function () {
          if (!live()) return;
          if (res.products && res.products.length) cards(res.products);
          if (res.more && res.more.length) moreBtn(res.more);
          if (res.action) add({ k: 'a', label: res.action.label, q: res.action.q });
          if (res.chips && res.chips.length) chips(res.chips, true);
          scrollDown();
        };
        if (said && said.typed) return said.typed.then(rest);   // let the text finish first
        rest();
      })
      .catch(function (e) {
        if (t.parentNode) t.remove();
        if (window.console) console.warn('[AI Shop Assistant]', e);
        if (live()) say(withContact('Sorry, something went wrong on my side. Please try again, or contact our team:'));
      })
      .then(function () { if (live()) setBusy(false); scrollDown(); });
  }

  function respond(text) {
    var pq = parse(text);
    var n = pq.n;
    var isQuestion = QUESTION_RE.test(' ' + text.toLowerCase().trim());
    var isShopping = SHOP_RE.test(n) || pq.price.max != null || pq.price.min != null || pq.sort === 'sale' || pq.sort === 'new';
    var vendors = vendorsIn(n);

    var st = storeAnswer(n);
    if (st && !(isShopping && pq.intents.length)) return Promise.resolve(st);

    var kb = knowledge(n);
    if (kb && !isShopping && isQuestion) {
      var res = { text: kb.text };
      if (kb.intent) {
        var it = INTENTS.filter(function (x) { return x.id === kb.intent; })[0];
        res.action = { label: 'Show ' + it.label.toLowerCase(), q: it.label };
      }
      return Promise.resolve(res);
    }

    var looksLikeProductName = !isQuestion && pq.tokens.length > 0 && pq.tokens.length <= 5;
    var wantsProducts = isShopping || vendors.length || (pq.intents.length && !isQuestion) || looksLikeProductName;
    if (wantsProducts && catalog && catalog.length) {
      var r = search(pq);
      if (r.list.length) {
        var intro;
        if (kb) intro = kb.text + '\n\nHere are some options:';
        else if (pq.intents.length === 1 && !vendors.length) intro = pq.intents[0].reply;
        else intro = 'Here\'s what I found for "' + text + '":';
        if (pq.price.max != null) intro += '\n(Under ' + money(pq.price.max) + ')';
        if (pq.sort === 'asc') intro += '\nSorted from lowest price.';
        // No topic suggestions here: the products are the answer, and chips
        // underneath them just push the cards up the screen.
        return Promise.resolve({ text: intro, products: r.list.slice(0, MAX), more: r.list.slice(MAX, MAX + 6), chips: [] });
      }
      if (isShopping || looksLikeProductName || vendors.length) {
        return predictive(text).then(function (ps) {
          if (ps.length) return { text: 'Here\'s what matches "' + text + '":', products: ps.slice(0, MAX), chips: [] };
          if (pq.sort === 'sale') return { text: 'There are no discounted products right now. Tell me what you\'re looking for and I\'ll find the best options.', chips: STARTERS };
          if (isShopping || vendors.length) {
            var budget = pq.price.max != null ? ' Nothing matched in that price range, so try a slightly higher budget.' : '';
            return { text: 'I couldn\'t find a product matching "' + text + '".' + budget + ' Try a brand, product name or goal, or pick a topic below:', chips: STARTERS };
          }
          return fallback();
        });
      }
    }

    if (pq.intents.length) {
      var first = pq.intents[0];
      return Promise.resolve({ text: 'That\'s a good question, but I don\'t have a reliable answer for it here. Our team can help with product-specific advice, or I can show you what we have in ' + first.label.toLowerCase() + '.', action: { label: 'Show ' + first.label.toLowerCase(), q: first.label } });
    }

    return Promise.resolve(fallback());
  }
  function fallback() {
    return { text: withContact('Sorry, I\'m not sure about that. I can help you find products (try a brand, a category like "face serum", or a budget like "sunscreen under 100"), or answer common questions about products, delivery and payment. For anything else, our team can help:'), chips: STARTERS.slice(0, 4) };
  }

  function welcome() {
    endTurn();
    history = []; saveHistory(); log.innerHTML = '';
    say(cfg.greeting || ('Hi! 👋 I\'m your ' + (cfg.agentName || 'AI Shop Assistant') + '. Tell me your goal — or tap a suggestion below — and I\'ll help you find the right products.'));
    add({ k: 'l', t: 'Popular topics' });
    chips(STARTERS, false);
    add({ k: 'l', t: 'Or try asking' });
    qchips(EXAMPLES);
    log.scrollTop = 0;
  }
  function restore() {
    log.innerHTML = '';
    history.forEach(render);
    markHistory();
  }
  function markHistory() { root.classList.toggle('aisa-has-chat', history.length > 3); }

  /* ---------- Open / minimize / close ---------- */
  var backdrop = root.querySelector('.aisa-backdrop');
  var mobile = window.matchMedia('(max-width: 575px)');
  var OKEY = 'aisa_open';
  function lock(on) { document.documentElement.classList.toggle('aisa-lock', !!on && mobile.matches); }
  function open() {
    root.dataset.open = 'true'; panel.hidden = false; backdrop.hidden = false; launcher.setAttribute('aria-expanded', 'true');
    lock(true);
    var fresh = false;
    if (!log.childNodes.length) { if (history.length) { restore(); } else { welcome(); fresh = true; } }
    if (fresh) log.scrollTop = 0; else scrollDown();
    setTimeout(function () { if (!mobile.matches) input.focus(); }, 50);
    try { sessionStorage.setItem(OKEY, '1'); } catch (e) {}
  }
  function hide(noFocus) {
    root.dataset.open = 'false'; panel.hidden = true; backdrop.hidden = true; launcher.setAttribute('aria-expanded', 'false');
    lock(false); markHistory();
    if (!noFocus) launcher.focus();
    try { sessionStorage.removeItem(OKEY); } catch (e) {}
  }
  function minimize() { hide(); setTimeout(function () { if (window.AISA_DOCK) window.AISA_DOCK.arrange(); }, 50); }
  function close() { endTurn(); hide(); history = []; saveHistory(); log.innerHTML = ''; input.value = ''; markHistory(); }
  if (mobile.addEventListener) mobile.addEventListener('change', function () { lock(root.dataset.open === 'true'); });

  function on(sel, ev, fn) { var n = root.querySelector(sel); if (n) n.addEventListener(ev, fn); }
  if (launcher) launcher.addEventListener('click', open);
  root.querySelectorAll('[data-aisa-close]').forEach(function (b) { b.addEventListener('click', function () { close(); }); });
  on('[data-aisa-minimize]', 'click', function () { minimize(); });
  on('[data-aisa-reset]', 'click', function () { welcome(); if (!mobile.matches) input.focus(); });
  on('[data-aisa-form]', 'submit', function (e) { e.preventDefault(); ask(input.value); if (mobile.matches) input.blur(); });
  // A disabled send button means Enter fires no submit at all, so the shopper
  // would get no sign that the message went nowhere. Answer the keypress itself.
  on('[data-aisa-input]', 'keydown', function (e) {
    if (e.key === 'Enter' && busy && String(input.value).trim()) { e.preventDefault(); nudge(); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.dataset.open === 'true') minimize(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#ai_shop_assistant"], a[href*="/pages/ai_shop_assistant"], a[href*="/pages/ai-shop-assistant"]');
    if (a) { e.preventDefault(); open(); }
  });
  if (history.length) restore();
  var wasOpen = false;
  try { wasOpen = sessionStorage.getItem(OKEY) === '1'; } catch (e) {}
  // Auto-open only on the assistant's own page (and never on a phone, where the
  // panel is a full-screen sheet) — elsewhere it waits to be tapped.
  if ((cfg.autoOpen !== false && !mobile.matches) || wasOpen) open(); else markHistory();
  window.AIShopAssistant = { open: open, close: close, minimize: minimize, ask: function (q) { open(); ask(q); } };
})();